import { Form } from "react-bootstrap";

import {
  Card,
  CollapseToggle,
  GridForm,
  GridFormItemWrapper,
} from "@bagel-web/components";

import OrganizationServiceSelect from "../../service/OrganizationServiceSelect";
import ServiceParamValueField, {
  ServiceParamValue,
} from "../../service/ServiceParamValueField";
import {
  CommonOrganizationService,
  fetchOrganizationServicesCallback,
  PlaygroundServiceConfig,
} from "../../types";
import { validateServiceParameter } from "../../util/services";

// The Services card: the Agent LLM picker over the org's LLM services, with
// the selected service's params behind a toggle.
const ServicesCard = ({
  llmService,
  llmServiceName,
  selectedService,
  fetchOrganizationServices,
  onServiceChange,
  onParamChange,
}: {
  // The agent_llm chain's service entry, when the config has one, and the
  // org service it names.
  llmService: PlaygroundServiceConfig | undefined;
  llmServiceName: string | null;
  // That org service's definition, with the param schemas it allows.
  selectedService: CommonOrganizationService | undefined;
  fetchOrganizationServices: fetchOrganizationServicesCallback;
  onServiceChange: (serviceName: string) => void;
  onParamChange: (name: string, value: ServiceParamValue) => void;
}) => {
  const paramEntries = llmService
    ? Object.entries(selectedService?.allowed_params ?? {})
    : [];
  return (
    <Card title="Services">
      <GridForm $width="100%" $numCols={2}>
        <GridFormItemWrapper>
          <Form.Label htmlFor="playground-agent-llm">Agent LLM</Form.Label>
          <OrganizationServiceSelect
            inputId="playground-agent-llm"
            value={llmServiceName}
            serviceType="llm"
            fetchOrganizationServices={fetchOrganizationServices}
            onChange={(event) => onServiceChange(event.target.value)}
            placeholder="Select a service…"
          />
        </GridFormItemWrapper>
      </GridForm>
      {llmService && paramEntries.length > 0 && (
        <CollapseToggle
          id="playground-service-params"
          label="Parameters"
          className="mt-2"
        >
          <GridForm $width="100%" $numCols={2}>
            {paramEntries.map(([name, schema]) => {
              const raw = llmService[name];
              const value =
                typeof raw === "string" ||
                typeof raw === "number" ||
                typeof raw === "boolean"
                  ? raw
                  : undefined;
              const fieldId = `playground-service-param-${name}`;
              return (
                <Form.Group className="mb-3" key={name}>
                  <Form.Label htmlFor={fieldId}>
                    <code>
                      {typeof schema.title === "string" ? schema.title : name}
                    </code>
                  </Form.Label>
                  <ServiceParamValueField
                    id={fieldId}
                    name={name}
                    schema={schema}
                    value={value}
                    placeholder={
                      schema.default !== undefined
                        ? String(schema.default)
                        : undefined
                    }
                    isInvalid={
                      value !== undefined &&
                      !validateServiceParameter(value, schema)
                    }
                    onChange={(next) => onParamChange(name, next)}
                  />
                  {typeof schema.description === "string" && (
                    <Form.Text muted>{schema.description}</Form.Text>
                  )}
                </Form.Group>
              );
            })}
          </GridForm>
        </CollapseToggle>
      )}
    </Card>
  );
};

export default ServicesCard;
